import { render, staticRenderFns } from "./ProductsCreateEdit.vue?vue&type=template&id=cd91bdd2&scoped=true&"
import script from "./ProductsCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductsCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd91bdd2",
  null
  
)

export default component.exports